import { useFormContext } from 'react-hook-form';
import { FieldComponentProps, ValidFieldTypes } from '../../../types';
import { accountNumber } from '../../../utils/regexp';
import { Text } from '../../FormContainer/FormTypes/Text';

export const AccountNumber = ({ isFetching }: FieldComponentProps) => {
  const { setValue, trigger } = useFormContext();

  return (
    <Text
      {...{
        params: {
          name: ValidFieldTypes.ACCOUNT_NUMBER,
          required: true,
          maxLength: 17,
          pattern: accountNumber,
          disabled: isFetching,
        },
        registerOptions: {
          onChange: (e) => {
            const result = e.currentTarget.value?.replace(/[^\d]/g, '');
            setValue(ValidFieldTypes.ACCOUNT_NUMBER, result);
            trigger(ValidFieldTypes.ACCOUNT_NUMBER);
          },
        },
      }}
    />
  );
};
